import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { PendingChangesDialogComponent } from '@shared/components/dialog/pending-changes/pending-changes-dialog.component';
import { Observable, Subject, tap } from 'rxjs';

@Injectable()
export class FormStateService {
  private _isDirty: WritableSignal<boolean> = signal<boolean>(false);

  public isDirty: Signal<boolean> = this._isDirty.asReadonly();

  private _isValid: WritableSignal<boolean> = signal<boolean>(false);

  public isValid: Signal<boolean> = this._isValid.asReadonly();

  private _clear$: Subject<void> = new Subject<void>();

  public clear$: Observable<void> = this._clear$.asObservable();

  public markDirty (): void {
    this._isDirty.set(true);
  }

  public setValidity (isValid: boolean): void {
    this._isValid.set(isValid);
  }

  public clear (): void {
    this._isDirty.set(false);
    this._isValid.set(false);
    this._clear$.next();
  }
}
export const pendingChangesGuard: CanDeactivateFn<unknown> = () => {
  const dirtyStateService: FormStateService = inject(FormStateService);
  const dialog: MatDialog = inject(MatDialog);


  if (!dirtyStateService.isDirty()) return true;

  return dialog.open(PendingChangesDialogComponent).afterClosed()
    .pipe(
      tap((isConfirmed: boolean) => {
        if (isConfirmed)
          dirtyStateService.clear();
      })
    );
};
